<template>
  <div class="dean-tooltip">
    <slot name="activator"></slot>
    <div class="text">
      <slot></slot>
    </div>
  </div>
</template>

<script lang="ts">
// VUE
import Vue from 'vue';
import { Component } from 'vue-property-decorator';

// COMPONENTS
@Component({})
export default class deanTooltip extends Vue {}
</script>

<style lang="scss" scoped>
// IMPORT
@import '../scss/vars';

// iOS fix for dropdown not leaving
body:hover {
  .text {
    visibility: hidden;
  }
}

// DEAN TOOLTIP
.dean-tooltip {
  position: relative;
  display: inline-block;
  cursor: pointer;

  &:hover .text {
    visibility: visible;
    top: 135%;
    opacity: 1;
  }

  .text {
    display: block;
    position: absolute;
    z-index: 998;
    overflow: visible;
    @include calc(top, 100% - 20%);
    left: 50%;
    margin-left: -50px;
    visibility: hidden;
    width: 100px;
    font-size: $font-medium;
    background-color: var(--color-dark-shade-2, $color-dark-shade-2);
    color: white;
    text-align: center;
    @include border-radius(5px);
    border: 1px solid var(--color-dark-shade-2, $color-dark-shade-2);
    padding: 5px 2.5px 5px 2.5px;
    opacity: 0;
    @include transition(all 0.5s ease);

    &:before {
      content: ' ';
      position: absolute;
      bottom: 100%;
      left: 50%;
      margin-left: -6px;
      border-width: 6px;
      border-style: solid;
      border-color: transparent transparent
        var(--color-dark-shade-2, $color-dark-shade-2) transparent;
    }

    &:after {
      content: ' ';
      position: absolute;
      bottom: 100%;
      left: 50%;
      margin-left: -5px;
      border-width: 5px;
      border-style: solid;
      border-color: transparent transparent
        var(--color-dark-shade-2, $color-dark-shade-2) transparent;
    }

    &:hover {
      visibility: hidden;
      opacity: 0;
    }
  }
}
</style>

<!-- README

// IMPORT COMPONENT

import {
  deanTooltip
} from '@deanone/dean-components'

// HTML

* slot="activator" on element that needs to be hovered
* Tooltip text in the custom element d-tooltip

EXAMPLE
<dean-tooltip>
  <button slot="activator" href="link">
    Example Button
  </button>
  Tooltip text
</dean-tooltip>

END README -->
